interface SectionHeadingProps {
  index: string;
  kicker: string;
  title: string;
  desc?: string;
  linkText?: string;
  light?: boolean;
}

export default function SectionHeading({
  index,
  kicker,
  title,
  desc,
  linkText,
  light = false,
}: SectionHeadingProps) {
  return (
    <div className="flex w-full flex-col gap-4 md:flex-row md:items-end md:justify-between">
      <div>
        <div className="flex items-center gap-2">
          <span
            className={`font-heading text-sm font-black tracking-[0.2em] ${
              light ? 'text-secondary-300' : 'text-primary-600'
            }`}
          >
            {index}
          </span>
          <span className="h-px w-6 bg-primary-400/70" />
          <span
            className={`text-xs font-semibold tracking-[0.25em] ${
              light ? 'text-background-200/70' : 'text-foreground-500'
            }`}
          >
            {kicker}
          </span>
        </div>
        <h2
          className={`font-heading mt-3 text-2xl font-black leading-snug md:text-3xl ${
            light ? 'text-background-50' : 'text-foreground-950'
          }`}
        >
          {title}
        </h2>
        {desc && (
          <p
            className={`mt-3 max-w-2xl text-sm leading-relaxed ${
              light ? 'text-background-200/80' : 'text-foreground-600'
            }`}
          >
            {desc}
          </p>
        )}
      </div>
      {linkText && (
        <a
          href="#top"
          className="group flex shrink-0 items-center gap-1.5 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          {linkText}
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
        </a>
      )}
    </div>
  );
}